// VNEC v9 — pages/project-select.js
// Trang chọn dự án cho data_entry sau khi login
import { getMyProjects, setCurrentProject } from '../lib/session.js';
import { signOut } from '../lib/supabase.js';
import { err } from '../components/toast.js';

export async function renderProjectSelect() {
  window.__pageInit = initProjectSelect;
  return `
    <div style="min-height:100vh;background:linear-gradient(135deg,#000066 0%,#1a1a5a 50%,#000066 100%);display:flex;align-items:center;justify-content:center;padding:20px">
      <div style="background:#FFF;border-radius:16px;max-width:720px;width:100%;padding:40px 48px;box-shadow:0 30px 80px rgba(0,0,0,0.4)">
        <div style="text-align:center;margin-bottom:28px">
          <div style="color:#FFCC00;font-size:28px;font-weight:800;letter-spacing:1px">VNEC v9</div>
          <div style="color:#666;font-size:12px;margin-top:4px">VINAENC ERP</div>
        </div>
        <h2 style="text-align:center;color:#000066;margin:0 0 8px;font-size:20px">🏗 Chọn dự án làm việc</h2>
        <p style="text-align:center;color:#666;font-size:13px;margin:0 0 28px">
          Phiên làm việc của bạn sẽ được gắn với dự án được chọn
        </p>
        <div id="ps-content">
          <div style="text-align:center;color:#888;padding:40px">Đang tải danh sách dự án...</div>
        </div>
        <div style="margin-top:24px;padding-top:20px;border-top:1px solid #EEE;text-align:center">
          <button type="button" id="ps-logout" style="background:none;border:none;color:#888;font-size:12px;cursor:pointer;text-decoration:underline">Đăng xuất</button>
        </div>
      </div>
    </div>`;
}

async function initProjectSelect() {
  const content = document.getElementById('ps-content');
  document.getElementById('ps-logout').addEventListener('click', async () => {
    await signOut();
  });

  try {
    const projects = await getMyProjects(true);

    if (!projects.length) {
      content.innerHTML = `
        <div style="padding:30px;background:#FEF2F2;border:1px solid #FCA5A5;border-radius:8px;text-align:center">
          <div style="font-size:32px;margin-bottom:10px">🚫</div>
          <div style="color:#991B1B;font-weight:700;margin-bottom:6px">Chưa được cấp quyền dự án</div>
          <div style="color:#7F1D1D;font-size:12px">Vui lòng liên hệ admin để được cấp quyền vào ít nhất 1 dự án.</div>
        </div>`;
      return;
    }

    content.innerHTML = `
      <div style="display:grid;gap:10px;max-height:50vh;overflow-y:auto">
        ${projects.map(p => `
          <button type="button" class="ps-card" data-ma="${p.ma_da}"
            style="text-align:left;background:#F4F4FB;border:2px solid #E5E5F0;border-radius:10px;padding:18px 20px;cursor:pointer;transition:all .15s;font-family:inherit;width:100%">
            <div style="display:flex;justify-content:space-between;align-items:center">
              <div>
                <div style="font-size:15px;font-weight:800;color:#000066">${p.ma_da}${p.is_default ? ' ⭐' : ''}</div>
                <div style="font-size:12px;color:#666;margin-top:3px">${p.ten_da || ''}</div>
              </div>
              <div style="color:#1B6B3A;font-size:20px">→</div>
            </div>
          </button>
        `).join('')}
      </div>`;

    document.querySelectorAll('.ps-card').forEach(btn => {
      btn.addEventListener('mouseenter', () => {
        btn.style.background = '#EEEDFE';
        btn.style.borderColor = '#534AB7';
        btn.style.transform = 'translateX(4px)';
      });
      btn.addEventListener('mouseleave', () => {
        btn.style.background = '#F4F4FB';
        btn.style.borderColor = '#E5E5F0';
        btn.style.transform = 'translateX(0)';
      });
      btn.addEventListener('click', async () => {
        const maDa = btn.dataset.ma;
        btn.style.opacity = '0.6';
        btn.style.pointerEvents = 'none';
        try {
          await setCurrentProject(maDa);
          window.location.hash = '#/dashboard';
        } catch (e) {
          err('Lỗi: ' + e.message);
          btn.style.opacity = '1';
          btn.style.pointerEvents = 'auto';
        }
      });
    });
  } catch (e) {
    content.innerHTML = `<div class="error-box">Lỗi tải danh sách: ${e.message}</div>`;
  }
}
